import { Series } from './Series'

export const transformData = (data: Series): any[] => {
  return data.keys.reduce((total: any[], key, index) => {
    const obj: any = {
      key,
      label: data.labels[index],
      colors: data.colors,
    }

    data.values.forEach((valueArr, i) => {
      obj[`values${i}`] = valueArr[index]
    })

    data.colors.forEach((colorsArr, i) => {
      obj[`colors${i}`] = colorsArr[index]
    })

    total.push(obj)
    return total
  }, [])
}
